/** Tinted status capsules (company active, Auth0 sync, Pro/Pulse, agreement active, SSO configured / error). */
/** Shared capsule shape and type for every admin status pill: 12/16, weight 600. */
export const ADMIN_BADGE_BASE_CLASS =
    'inline-flex max-w-max items-center rounded-full px-2 py-0.5 text-xs font-semibold leading-4';

export const ADMIN_BADGE_POSITIVE_CLASS =
    'bg-green-50 text-green-700 ring-1 ring-inset ring-green-600/25';
export const ADMIN_BADGE_NEGATIVE_CLASS =
    'bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/25';
export const ADMIN_BADGE_WARNING_CLASS =
    'bg-amber-50 text-amber-800 ring-1 ring-inset ring-amber-600/25';
export const ADMIN_BADGE_NEUTRAL_CLASS =
    'bg-neutral-100 text-neutral-700 ring-1 ring-inset ring-neutral-300';
